
import { fetchApi } from '../../../../lib/fetchApi';
import { useCallback, useEffect, useState } from "react";
import { UseGetCampaingsObjectResult } from '../../campaign/types';


interface UseGetCampaingsResult {
    campaingData: UseGetCampaingsObjectResult[];
    fetchCampaignData: () => Promise<UseGetCampaingsObjectResult[] | null>;
}
export const useGetCampaigns = (): UseGetCampaingsResult => {
    const [campaingData, setCampaignData] = useState<UseGetCampaingsObjectResult[]>([]);

    const fetchCampaignData = useCallback(async (): Promise<UseGetCampaingsObjectResult[] | null> => {
        try {
         
            const response = await fetchApi.get(`/campaign/names`) as UseGetCampaingsObjectResult[];

            setCampaignData(response);
            return response;

        } catch (err) {
            return null;
        }
    }, []);

    useEffect(() => {
        fetchCampaignData();
    }, []);

    return { campaingData, fetchCampaignData };
}